import React from 'react';
import styled from 'styled-components';
import { spacing, borders } from '@tds/shared-styles';
import { safeRest } from '@tds/util-helpers';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

var StyledDimpleDivider = styled.hr.withConfig({
  displayName: "DimpleDivider__StyledDimpleDivider",
  componentId: "quxnvh-0"
})(spacing.noSpacing, borders.none, {
  height: '32px',
  backgroundImage: 'radial-gradient(ellipse at top, rgba(150, 150, 150, 0.1) 0%, rgba(0, 0, 0, 0) 70%)'
});
/**
 * Separate modules.
 *
 * @version ./package.json
 */

var DimpleDivider = function DimpleDivider(_ref) {
  var rest = _extends_1({}, _ref);

  return React.createElement(StyledDimpleDivider, safeRest(rest));
};

export default DimpleDivider;
